import React from "react";

export class PrivacyPolicyNL extends React.Component {
    render() {
        return (
            <>
                <p>
                    Laatste update: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    DH Healthcare GmbH, een Dedalus bedrijf hecht veel belang aan en wil bijzondere aandacht besteden aan de bescherming van uw persoonlijke informatie en het
                    respecteren van uw privacy.
                    <br />
                    Het doel van dit privacy beleid en informatieve kennisgeving voor websitegebruikers (hierna de "kennisgeving" genoemd) is dan ook om u te informeren over hoe uw
                    persoonlijke informatie wordt verzameld, gebruikt, opgeslagen of openbaar gemaakt (verwerkt) wanneer u een DeepUnity PACSonWEB portaal zoals bvb
                    secure.pacsonweb.com (hierna de "site" genoemd) bezoekt.
                    <br />
                    In dit verband wordt erop gewezen dat Dedalus optreedt als de verantwoordelijke (controller) voor uw persoonlijke informatie (hierna "wij", "ons" en "onze"
                    genoemd).
                    <br />
                    <br />
                    Wij bevestigen uitdrukkelijk dat alle persoonsgegevens zullen worden verwerkt in overeenstemming met de verordening 2016/679 van 27 april 2016 betreffende de
                    bescherming van natuurlijke personen in verband met de verwerking van persoonsgegevens. Dit is belangrijk en we moedigen u dan ook aan om de tijd te nemen dit
                    beleid zorgvuldig te lezen.
                </p>
                <h2>REIKWIJDTE VAN DIT PRIVACYBELEID</h2>
                <p>Dit privacybeleid is van toepassing</p>
                <ul>
                    <li>
                        op alle persoonlijke informatie, verzameld van de gebruikers van het DeepUnity PACSonWEB platform. Dit omvat zowel alle dokters, tandartsen, specialisten, …
                        die zich registreren voor en DeepUnity PACSonWEB gebruiken via een account als niet geregistreerde gebruikers die een onderzoek openen aan de hand van
                        referentienummer en geboortedatum.
                    </li>
                    <li>alle algemene voorwaarden en andere beleidsregels van DH Healthcare GmbH die van toepassing zijn op de verleende diensten,</li>
                </ul>
                <p>
                    Dit privacy beleid is niet van toepassing op de patiëntdata die DH Healthcare GmbH verwerkt in opdracht van de gekoppelde ziekenhuizen en radiologieafdelingen.
                    Dit omvat zowel de medisch data, gegenereerd door de radiologieafdeling als de medische data die via de upload functionaliteit door de patiënt zelf ter
                    beschikking wordt gesteld aan een radiologieafdeling. Hiervoor verwijzen we naar het privacybeleid van de betrokken radiologieafdeling.
                </p>
                <h2>1. WELKE PERSOONSGEGEVENS VERZAMELEN WIJ?</h2>
                <p>
                    Wanneer u ons portaal gebruikt, kunnen wij de volgende categorieën persoonsgegevens over u verzamelen:
                    <br />• identificatiegegevens (bijv. naam, voornaam, e-mailadres, gebruikersnaam, wachtwoord, regio, type apparaat, enz.)
                    <br />• beroepsgegevens (bijv. functie, werkterrein, werkgever).
                    <br />• technische gegevens (bv. IP-adres, type gebruikte browser, tijdstip van aanmelden enz.); en
                    <br />• alle persoonsgegevens in de correspondentie die u ons toestuurt.
                    <br />
                    <br />
                    Het verstrekken van uw persoonsgegevens is vrijwillig, maar zonder deze gegevens kunnen wij u niet de diensten en informatie verstrekken die u aanvraagt. Als u
                    bijvoorbeeld via de site contact met ons opneemt, moet u ons uw e-mailadres geven zodat wij u kunnen antwoorden.
                    <br />
                    <br />
                    In ieder geval zullen wij u informeren wanneer het verplicht is uw persoonsgegevens te verstrekken.
                    <br />
                    <br />
                    Indien u ons persoonsgegevens van derden verstrekt, verbindt u zich er bovendien toe dat deze personen naar behoren zijn geïnformeerd over de verwerking van hun
                    persoonsgegevens overeenkomstig dit beleid en, indien nodig, hebben ingestemd met de verwerking van hun persoonsgegevens.
                </p>
                <h2>2. WAAROM GEBRUIKEN WIJ UW PERSOONSGEGEVENS?</h2>
                <p>
                    De onderstaande tabel geeft een overzicht van de doeleinden waarvoor wij uw persoonsgegevens verwerken en, voor elk doel, de rechtsgrondslag voor de
                    desbetreffende verwerking:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>DOELEN</th>
                            <th>WETTELIJKE BASIS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registreren van een gebruikersaccount met implementatie van relevante beveiligde authenticatie en authorisatie methodes. Dit omvat bijvoorbeeld het
                                versturen van emails of tekstberichten for two-factor authenticatie protocollen;
                            </td>
                            <td>De verwerking is gebaseerd op uw toestemming.</td>
                        </tr>
                        <tr>
                            <td>Het automatisch versturen van een emails wanneer een nieuwe studie beschikbaar is voor de gebruiker in DeepUnity PACSonWEB;</td>
                            <td>De verwerking is gebaseerd op uw toestemming.</td>
                        </tr>
                        <tr>
                            <td>Traceerbaarheid van geregistreerde toegang tot medische informatie;</td>
                            <td>De verwerking is noodzakelijk om te voldoen aan de wettelijke verplichtingen waaraan wij onderworpen zijn.</td>
                        </tr>
                        <tr>
                            <td>
                                Aanleveren van lijst met geregistreerde gebruikers aan ziekenhuizen die DeepUnity PACSonWEB aanwenden voor distributie. Deze lijst omvat uitsluitend
                                Naam, Voornaam en Identificatienummer als arts (RIZIV, BIG, …)
                            </td>
                            <td>De verwerking is gebaseerd op ons gerechtvaardigd belang om onze klanten te informeren over het gebruik van de aangeboden diensten.</td>
                        </tr>
                        <tr>
                            <td>Reageren op verzoeken en vragen die u via de site stelt, en meer in het algemeen het beheren van onze relatie met bezoekers van de site.</td>
                            <td>Contract</td>
                        </tr>
                        <tr>
                            <td>Het verbeteren en beveiligen van onze diensten en onze site.</td>
                            <td>
                                De verwerking wordt uitgevoerd op grond van ons gerechtvaardigd belang, namelijk het optimaliseren en beveiligen van onze tools en oplossingen om
                                onze websitebezoekers, klanten en prospects zo goed mogelijk van dienst te zijn en onze online aanwezigheid veilig te houden.
                            </td>
                        </tr>
                        <tr>
                            <td>Het voldoen aan wettelijke en reglementaire verplichtingen die op ons van toepassing zijn.</td>
                            <td>De verwerking is noodzakelijk om te voldoen aan de wettelijke verplichtingen waaraan wij onderworpen zijn.</td>
                        </tr>
                        <tr>
                            <td>Het beheren van potentiële of feitelijke geschillen met u of derden.</td>
                            <td>
                                De verwerking wordt uitgevoerd op grond van ons legitieme belang, wat inhoudt dat wij onze belangen verdedigen, onder meer door gerechtelijke
                                stappen.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Het versturen, met zowel geautomatiseerde (bijv. e-mail, SMS, MMS, enz.) als niet-geautomatiseerde (bijv. telefoon, gewone post, enz.) middelen, van
                                marketingberichten en promotionele inhoudsberichten met betrekking tot onze activiteiten, producten en diensten en die van de andere Dedalus
                                groepsmaatschappijen (met inbegrip van marktonderzoek, klanttevredenheidsonderzoeken, informatie over webinars en evenementen) (marketing) De
                                verwerking wordt alleen uitgevoerd in het geval dat u specifieke toestemming geeft.
                            </td>
                            <td>De verwerking wordt alleen uitgevoerd indien u specifieke toestemming geeft</td>
                        </tr>
                        <tr>
                            <td>
                                Het doorgeven/delen van uw persoonsgegevens aan de andere Dedalus groepsmaatschappijen, actief in de bio medische sector, om hen in staat te stellen
                                via geautomatiseerde middelen (bijv. e-mail, SMS, MMS, enz.), marketingberichten en promotionele inhoudsberichten te versturen met betrekking tot
                                hun activiteiten, producten en diensten (waaronder marktonderzoek, klanttevredenheidsonderzoeken, informatie over webinars en evenementen);
                            </td>
                            <td>De verwerking vindt alleen plaats indien u daarvoor specifiek toestemming geeft</td>
                        </tr>
                    </tbody>
                </table>
                <p>In ieder geval zullen wij uw persoonsgegevens niet verwerken voor enig ander doel dat onverenigbaar is met de bovengenoemde doeleinden.</p>
                <h2>3. MET WIE DELEN WIJ UW PERSOONSGEGEVENS?</h2>
                <p>
                    In het kader van onze verwerkingsactiviteiten kunnen wij uw persoonsgegevens meedelen aan de volgende ontvangers
                    <br />• aan onze dienstverleners, leveranciers, agenten en contractanten, voor zover zij ons helpen bij het uitvoeren van de in dit beleid uiteengezette
                    doeleinden (wij maken bijvoorbeeld gebruik van IT-dienstverleners om uw persoonsgegevens namens ons te hosten;
                    <br />• de andere entiteiten van de Dedalus Groep, voor zover zij ons helpen bij het uitvoeren van de in dit beleid uiteengezette doeleinden
                    <br />• aan bevoegde rechtbanken, openbare instanties, overheidsinstellingen en wetshandhavingsinstanties (ook wanneer wij moeten voldoen aan wettelijke of
                    regelgevende verzoeken).
                    <br />
                    <br />
                    Ongeacht de ontvanger, zullen wij uw persoonlijke gegevens alleen aan hen bekendmaken op een strikt noodzakelijke basis en alleen in de mate die nodig is om de
                    in dit beleid vermelde doeleinden te vervullen.
                    <br />
                    <br />
                    Wij verkopen uw persoonsgegevens niet.
                </p>
                <h2>4. GEVEN WIJ GEGEVENS DOOR BUITEN DE EUROPESE ECONOMISCHE RUIMTE?</h2>
                <p>
                    Voor alle landen binnen de Europese Economische Ruimte geldt dat persoonlijke gezondheidsgegevens die door DeepUnity PACSonWEB worden verwerkt, niet worden doorgegeven aan landen buiten dit gebied.
                </p>
                <p>
                    Indien uw persoonsgegevens buiten de Europese Economische Ruimte ("EER") worden doorgegeven, zorgen wij ervoor dat het beschermingsniveau van uw
                    persoonsgegevens door dergelijke doorgiften niet negatief wordt beïnvloed.
                </p>
                <p>Dit betekent specifiek dat elk van de voorgenomen overdrachten ten minste gebaseerd is op een van de volgende mechanismen</p>
                <ul>
                    <li>
                        het bestaan van een door de Europese Commissie afgegeven adequaatheidsbesluit voor het land waarnaar uw persoonsgegevens worden doorgegeven; of, als
                        alternatief;
                    </li>
                    <li>het sluiten van modelcontractbepalingen die de door de Europese Commissie goedgekeurde modellen overnemen; of anders</li>
                    <li>
                        het bestaan van een vrijstelling in verband met een van de specifieke situaties waarin de Algemene Verordening Gegevensbescherming 2016/679 ("GDPR")
                        limitatief voorziet (bijvoorbeeld wanneer u uw toestemming voor een dergelijke doorgifte hebt gegeven nadat u op de hoogte bent gebracht van het ontbreken
                        van waarborgen, wanneer de doorgifte noodzakelijk is voor de uitvoering van een tussen u en ons gesloten overeenkomst, wanneer de doorgifte noodzakelijk is
                        voor de sluiting of uitvoering van een in uw belang gesloten overeenkomst tussen ons en een derde, of wanneer de doorgifte noodzakelijk is voor de
                        vaststelling, uitoefening of verdediging van onze rechtsvorderingen, enzovoort).
                    </li>
                </ul>
                <h2>5. HOE LANG BEWAREN WIJ UW PERSOONSGEGEVENS?</h2>
                <p>
                    Wij bewaren uw persoonsgegevens niet langer dan noodzakelijk is voor het doel van de betreffende verwerking.
                    <br />
                    <br />
                    Met andere woorden, dit betekent dat de bewaartermijnen die wij hanteren variëren afhankelijk van het doel waarvoor wij de betreffende gegevens verwerken. In
                    onderstaande tabel wordt daarom per doel aangegeven welke bewaartermijn op uw persoonsgegevens wordt toegepast:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>DOELEN</th>
                            <th>BEWAARTERMIJN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registreren van een gebruikersaccount met implementatie van relevante beveiligde authenticatie en authorisatie methodes. Dit omvat bijvoorbeeld het
                                versturen van emails of tekstberichten for two-factor authenticatie protocollen;
                            </td>
                            <td>
                                De persoonsgegevens, verschaft in the kader van een accountregistratie worden bewaard voor een periode van 2 jaar na de laatstse succesvolle
                                inlogpoging.
                            </td>
                        </tr>
                        <tr>
                            <td>Het automatisch versturen van een emails wanneer een nieuwe studie beschikbaar is voor de gebruiker in DeepUnity PACSonWEB;</td>
                            <td>
                                De persoonsgegevens, verschaft in the kader van een accountregistratie worden bewaard voor een periode van 2 jaar na de laatstse succesvolle
                                inlogpoging.
                            </td>
                        </tr>
                        <tr>
                            <td>Traceerbaarheid van geregistreerde toegang tot medische informatie;</td>
                            <td>10 jaar</td>
                        </tr>
                        <tr>
                            <td>
                                Aanleveren van lijst met geregistreerde gebruikers aan ziekenhuizen die DeepUnity PACSonWEB aanwenden voor distributie. Deze lijst omvat uitsluitend
                                Naam, Voornaam en Identificatienummer als arts (RIZIV, BIG, …)
                            </td>
                            <td>
                                De persoonsgegevens, verschaft in the kader van een accountregistratie worden bewaard voor een periode van 2 jaar na de laatstse succesvolle
                                inlogpoging.
                            </td>
                        </tr>
                        <tr>
                            <td>Reageren op verzoeken en vragen die u via de site stelt, en meer in het algemeen het beheren van onze relatie met bezoekers van de site.</td>
                            <td>Reageren op verzoeken en vragen die u via de site stelt, en meer in het algemeen het beheren van onze relatie met bezoekers van de site.</td>
                        </tr>
                        <tr>
                            <td>Wij bewaren uw persoonsgegevens maximaal 2 jaar vanaf ons laatste contact met u.</td>
                            <td>Wij bewaren uw persoonsgegevens maximaal 2 jaar vanaf ons laatste contact met u.</td>
                        </tr>
                        <tr>
                            <td>Het verbeteren van onze diensten en onze site.</td>
                            <td>Het verbeteren van onze diensten en onze site.</td>
                        </tr>
                        <tr>
                            <td>
                                Wij bewaren uw gegevens maximaal één jaar, hoewel uw gegevens in de meeste gevallen kort na verzameling worden samengevoegd tot
                                niet-identificeerbare statistieken.
                            </td>
                            <td>
                                Wij bewaren uw gegevens maximaal één jaar, hoewel uw gegevens in de meeste gevallen kort na verzameling worden samengevoegd tot
                                niet-identificeerbare statistieken.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Het versturen, met zowel geautomatiseerde (bijv. e-mail, SMS, MMS, enz.) als niet-geautomatiseerde (bijv. telefoon, gewone post, enz.) middelen, van
                                marketingberichten en promotionele inhoud berichten met betrekking tot onze activiteiten, producten en diensten en die van de andere Dedalus groep
                                bedrijven (met inbegrip van marktonderzoek, klanttevredenheidsonderzoeken, informatie over webinars en evenementen) (marketing).
                            </td>
                            <td>Wij verwerken uw persoonsgegevens totdat uw toestemming wordt ingetrokken.</td>
                        </tr>
                        <tr>
                            <td>
                                Doorgeven/doorgeven van uw persoonsgegevens aan de andere Dedalus groepsmaatschappijen, actief in de bio medische sector, via geautomatiseerde
                                middelen (bijv. e-mail, SMS, MMS, enz.), marketing berichten en promotionele inhoud berichten met betrekking tot hun activiteiten, producten en
                                diensten (inclusief marktonderzoek, klanttevredenheidsonderzoeken, informatie over webinars en evenementen);
                            </td>
                            <td>Wij verwerken uw persoonsgegevens totdat uw toestemming wordt ingetrokken</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    In ieder geval zullen wij na afloop van de geldende bewaartermijn uw persoonsgegevens onherroepelijk wissen of anonimiseren, zodat u niet meer kunt worden
                    geïdentificeerd.
                </p>
                <h2>6. GEBRUIKEN WE COOKIES?</h2>
                <p>
                    Wij gebruiken cookies op onze site.
                    <br />
                    Voor meer informatie over de cookies die wij gebruiken en de doeleinden waarvoor wij ze gebruiken, verwijzen wij naar ons cookiebeleid, dat te vinden is in het
                    privacy gedeelte van de websitepagina.
                </p>
                <h2>7. WELKE RECHTEN HEB JE?</h2>
                <p>
                    In overeenstemming met het toepasselijke rechtskader voor gegevensbescherming, met name de GDPR, heeft u als betrokkene de volgende rechten:
                    <br />• U kunt toegang vragen tot uw persoonsgegevens en verzoeken deze te rectificeren of te wissen.
                    <br />• U hebt ook het recht om te verzoeken dat de verwerking van uw persoonsgegevens wordt beperkt of om daartegen bezwaar te maken.
                    <br />• U hebt het recht op overdraagbaarheid van uw persoonsgegevens.
                    <br />• Wanneer de verwerking van uw persoonsgegevens is gebaseerd op uw toestemming, kunt u uw toestemming te allen tijde intrekken, zonder dat dit gevolgen
                    heeft voor de rechtmatigheid van de verwerking die op uw toestemming is gebaseerd en die plaatsvond voordat u deze introk.
                    <br />
                    <br />
                    Sommige van de bovengenoemde rechten zijn echter onderworpen aan specifieke voorwaarden die worden opgelegd door het toepasselijke rechtskader voor
                    gegevensbescherming. Als uw specifieke situatie niet aan deze voorwaarden voldoet, kunnen wij helaas niet aan uw verzoek voldoen.
                    <br />
                    Om uw rechten uit te oefenen, kunt u contact opnemen met onze DPO via de contactgegevens in Sectie 8 (Hoe kunt u contact met ons opnemen?).
                    <br />
                    Om uw verzoek zo efficiënt mogelijk te verwerken, kunnen wij u om bepaalde aanvullende informatie vragen om uw identiteit te bevestigen en/of te helpen bij het
                    lokaliseren van de persoonsgegevens die het onderwerp van uw verzoek vormen.
                    <br />
                    <br />
                    In elk geval kunt u een klacht indienen bij de bevoegde toezichthoudende autoriteit voor gegevensbescherming. Een lijst met de Europese bevoegde
                    toezichthoudende autoriteiten is beschikbaar op volgende site: https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm
                </p>
                <h2>8. HOE KUNT U CONTACT MET ONS OPNEMEN?</h2>
                <p>
                    Als u vragen of verzoeken hebt over onze verwerking van uw persoonsgegevens in het kader van dit beleid, inclusief de uitoefening van uw rechten, zoals
                    hierboven beschreven, kunt u contact met ons opnemen op het volgende adres: info@dobcomed.com
                    <br />
                    <br />
                    Wij hebben ook een functionaris voor gegevensbescherming ("DPO") aangesteld, waarmee u per e-mail contact kunt opnemen op het volgende adres:
                    <br />
                    voor Dedalus S.p.A. dpo.group@dedalus.eu
                    <br />
                    voor Millennium S.r.l. dpo.millennium@dedalus.eu
                    <br />
                    voor andere in Italië gevestigde bedrijven dpo@dedalus.eu
                    <br />
                    voor bedrijven gevestigd in het Verenigd Koninkrijk dpo-uk@dedalus.group
                    <br />
                    voor bedrijven gevestigd in Frankrijk dpo.france@dedalus.eu
                    <br />
                    voor bedrijven gevestigd in Duitsland/Oostenrijk en Zwitserland dpo.dach@dedalus.com
                    <br />
                    voor DH Healthcare GmbH en andere bedrijven gevestigd in België dpo.belgium@dedalus.eu
                    <br />
                    voor overige bedrijven dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
